var map = {
	"./de/title.png": "mi6a",
	"./en/title.png": "Iwrb",
	"./es/title.png": "62Bi",
	"./fr/title.png": "4f2X",
	"./ja/title.png": "XiUW",
	"./ko/title.png": "WhKG",
	"./pt/title.png": "QO46",
	"./ru/title.png": "Z7Ix",
	"./tc/title.png": "0oWh",
	"./th/title.png": "EN1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "I3Kd";